import React, { Fragment, useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import TechHire from '../features/tech_hire/TechHire';
import { useDispatch } from 'react-redux';
import { fetchDeveloperByRoleOrSkill, fetchFaqsByRoleOrSkill } from '../redux/action/homeAction';
import useDocumentTitle from '../hooks/useDocumentTitle';

const SkillOrRole = () => {
    useDocumentTitle("Hire Developer");

    const { slug } = useParams();
    const dispatch = useDispatch()
    const location = useLocation()
    const faqParams = location.pathname.includes("skill") ? `skills/${slug}/` : `specializations/${slug}/`
    const params = location.pathname.includes("skill") ? `skills=${slug}` : `specialization__slug=${slug}`

    useEffect(() => {
        dispatch(fetchDeveloperByRoleOrSkill(params))
        dispatch(fetchFaqsByRoleOrSkill(faqParams))
        // eslint-disable-next-line
    }, [slug])

    return (
        <Fragment>
            <Header />
            <TechHire />
            <Footer />
        </Fragment>
    )
}

export default SkillOrRole;